import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';
import { filtersConfig } from '../utils';
import { getById } from '@/services/global';

const namespace = 'delegationConfigurations';

const DelegationConfigurationsModel = {
  namespace,
  state: {
    ...initialState,
    filtersConfig,
    delegationStatus: null,
  },
  effects: {
    ...makeListEffects({
      namespace,
      fetchRoute: 'delegation/config',
      fetchParams: 'delegationConfigurations',
    }),
    *fetchDelegationStatus({ payload }, { call, put }) {
      const response = yield call(getById, {
        route: payload.route,
        id: payload.id,
        params: payload.params,
      });
      yield put({
        type: 'saveDelegationStatus',
        payload: response,
      });
    },
    *fetchItem({ payload }, { put }) {
      try {
        yield put({ type: 'success', payload: false });
        yield put({ type: 'queryItem', payload: payload });
      } catch (e) {}
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),
    saveDelegationStatus(state, { payload }) {
      return {
        ...state,
        delegationStatus: payload?.status || 0,
      };
    },
    queryItem(state, { payload }) {
      return {
        ...state,
        item: payload,
      };
    },
  },
};

export default DelegationConfigurationsModel;
